<template>
  <div class="app-preview-page">
    <div class="app-preview-card">
      <div class="toolbar">
        <div>
          <div class="title">APP 预览</div>
          <div class="muted">{{ url }}</div>
        </div>
        <el-button type="primary" icon="el-icon-top-right" @click="openExternal">新窗口打开</el-button>
      </div>
      <iframe class="app-preview-frame" :src="url" referrerpolicy="no-referrer"></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "appPreview",
  data() {
    return {
      url: "https://app.tianxuanji.com/",
    };
  },
  methods: {
    openExternal() {
      window.open(this.url, "_blank");
    },
  },
};
</script>

<style scoped>
.app-preview-page {
  width: 100%;
  height: 100%;
  background: #f5f7fb;
  overflow: auto;
}
.app-preview-card {
  width: 98%;
  height: 95%;
  margin: 1.5% auto;
  padding: 18px;
  background: #fff;
  box-shadow: #e0e0e0 5px 5px 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 14px;
}
.title {
  color: #1f2d3d;
  font-size: 22px;
  font-weight: 700;
}
.muted {
  color: #7f8fa4;
  font-size: 13px;
  margin-top: 6px;
}
.app-preview-frame {
  width: 100%;
  flex: 1;
  min-height: 0;
  border: 1px solid #dfe6ef;
  background: #fff;
}
</style>
